import {isArray} from '@shared/helpers/lang'

import {isMobileDisplay} from '@web/helpers/userAgent'
import {uiEventLoggerCreator, uiEventAction, pageViewAction} from '@web/middlewares/uiLogging'

import {nClicksMap} from '../../../constants'
import {MemberRootState as RootState} from '../../../interfaces'

const uiEventLogger = uiEventLoggerCreator<RootState>({
    nClicksTargetMap: nClicksMap,
    convertNClicksCode: ({value}) => {
        return isArray(value) ? (isMobileDisplay ? value[0] : value[1]) : value
    },
})

export const uiEventActions = [uiEventAction.type, pageViewAction.type]

export default uiEventLogger
